import React from 'react'
import styles from './styles.module.scss'
import { RatingTier } from '../../../HowWeRate/components/RatingTier'
import { useAppIntl } from 'src/i18n'

export const RatingTierModal = ({ attributes, closeModal, modalStyle }) => {
  const intl = useAppIntl()

  return (
    <div className={`${styles.modal} ${styles[modalStyle]}`}>
      <div className={styles.modal__content}>
        <h3 className={styles.modal__title}>
          {intl.t('review.ratingTier.title')}
        </h3>
        <h2 className={styles.modal__name}>{attributes.name}</h2>
        <RatingTier backgroundColor={'#2D2D2D'} attributes={attributes} />
      </div>
      <button onClick={closeModal} className={styles.modal__button}>
        {intl.t('review.ratingTier.closeButton')}
      </button>
    </div>
  )
}
